


import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import LineString from 'ol/geom/LineString';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import Overlay from 'ol/Overlay.js';
import OSM from 'ol/source/OSM.js';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer.js';
import { Vector as VectorSource,TileImage } from 'ol/source.js';
import { Circle as CircleStyle, Fill, RegularShape, Stroke, Style, Text, Icon } from 'ol/style.js';

import {fromLonLat} from 'ol/proj.js';

import $ from  'jquery';
import {getSrcLongdo} from "../../../../../util/util.js";

const raster = new TileLayer({
  visible: false,
  // source: new OSM()
  source: new TileImage({ url: 'http://mt{0-3}.googleapis.com/vt?lyrs=m@179000000&hl=en&&x={x}&y={y}&z={z}' })
});

let longdo = new TileLayer({
  
  // source: new TileImage({ url: 'http://ms.longdo.com/map/msn-server/img.php?HD=1&zoom={z}&x={x}&y={y}' })
  source: getSrcLongdo()//new TileImage({ url: "http://ms.longdo.com/map/msn-server/img.php?HD=1&zoom={z}&x={x}&y={y}&mode=icons&key=e7e08f7f6a256213042d69020f6628fe&proj=epsg3857" })
});

let traffic = new TileLayer({
  visible: false,
  source: new TileImage({ url: 'https://mstraffic1.longdo.com/mmmap/img.php?mode=trafficoverlay&HD=1&zoom={z}&x={x}&y={y}' })
});

const sat =new TileLayer(
{ 
  visible: false,
  source: new TileImage({ url: 'http://mt{0-3}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}'  })//'http://khm{0-3}.googleapis.com/kh?v=742&hl=pl&&x={x}&y={y}&z={z}'
})

const textFill = new Fill({
  color: '#fff'
});
const textStroke = new Stroke({
  color: 'rgba(0, 0, 0, 0.6)',
  width: 3
});

const iconPinTracker = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/pin_car.png',
  //color: '#8959A8'
}));

let iconCar = function (icon,color) {
  if(!icon || icon == null){
    icon = "car-side";
    color = "#5DADE2";
  }
    
  return new Icon(/** @type {module:ol/style/Icon~Options} */({
    anchorXUnits: 'fraction',
    anchorYUnits: 'pixels',
    anchorOrigin: "bottom-left",
    src: 'images/pin/'+icon+'.png',
    anchor: [0.48, -26],
    color: color
  }));
}

let carVector = null;
let carSource = null;


let map = new Map({
  layers: [],
  overlays: [],
  target: 'mapAlert',
  view: new View({
    center: fromLonLat([100, 13]),
   // projection: 'EPSG:4326',
    minZoom: 5,
    maxZoom: 19,
    zoom : 6
  })
});

let viewMain = new View({
  center: fromLonLat([100, 13]),
  //projection: 'EPSG:4326',
  minZoom: 5,
  maxZoom: 19,
  zoom: 6
});

function createPinGroupOverStyle(feature) {
  return [new Style({
    //geometry: feature.getGeometry(),
    image: iconPinTracker,
    text: new Text({
      fill: textFill,
      font: '14px sans-serif',
      stroke: textStroke,
      offsetY: -20,
      text: feature.get('number').toString()
    })

  }),
  new Style({
    //geometry: feature.getGeometry(),
    image: feature.get('symbol_id')? iconCar(feature.get('symbol_id').toString(),feature.get('symbol_color').toString()):iconCar(),//อาจช้า
  })];
}

function intMap(point) {
  carSource = new VectorSource({
    features: point
  });

  carVector = new VectorLayer({
    name: "car",
    source: carSource,
    style: createPinGroupOverStyle
  });
  map.addLayer(carVector);
  let extent = carVector.getSource().getExtent();
  map.getView().fit(extent, map.getSize());
}

export function zoomTo(index,lat,lng,text,symbolId,symbolColor){
  let coordinates = fromLonLat([lng, lat]);
  let car = new Array(1);
      
  car[0] = new Feature(
    {
      labelPoint: new Point(coordinates),
      number: text,
      symbol_id: symbolId,
      symbol_color: symbolColor,
      index: index,
      
    }
  );
  car[0].setGeometryName('labelPoint');

  if(carSource==null){
    intMap(car);
  }else{
    carSource.clear();
    carSource.addFeatures(car);
    carSource.refresh();
  }
  
  map.getView().setCenter(coordinates);
  map.getView().setZoom(15);
  
}


export function setMapToggle(mapTogglePath){
  if(mapTogglePath.indexOf('type_sat.png')>-1){
    mapTogglePath = mapTogglePath.replace('type_sat','type_map');
    if(m_isGoogleMap)
      raster.setVisible(false);
    else
      longdo.setVisible(false);
    sat.setVisible(true);
  }
  else{
    if(m_isGoogleMap)
      raster.setVisible(true);
    else
      longdo.setVisible(true);
    sat.setVisible(false);
     mapTogglePath = mapTogglePath.replace('type_map','type_sat');
  }
  return mapTogglePath;
}

export function setTrafficToggle(trafficTogglePath){
  if(trafficTogglePath.indexOf('traffic.png')>-1){
    trafficTogglePath = trafficTogglePath.replace('traffic','traffic_a');
    traffic.setVisible(true);
  }else{
    trafficTogglePath = trafficTogglePath.replace('traffic_a','traffic');
    traffic.setVisible(false);
  }
  return trafficTogglePath;
}

export function switchBaseMap(isGoogle){
  console.log(isGoogle)
  m_isGoogleMap = isGoogle;
  raster.setVisible(m_isGoogleMap);
  longdo.setVisible(!m_isGoogleMap);
}

let m_isGoogleMap = false;


export function updateMapSize(){
  if(map!=null){
    map.updateSize();
  }
 
}

export function setDefaultMap(){
  map = new Map({
    layers: [raster,longdo,sat,traffic],
    target: 'mapAlert',
    view: viewMain
  });

  
}

export function clearMapTracking() {
  longdo.setVisible(true);
  sat.setVisible(false);
  traffic.setVisible(false);
  map=null;
  carSource=null;
}


// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/MapAlert/js/MapAlert.js